import React from 'react';
export function Header() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 border-b border-gray-100" data-id="element-68">
      <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-69">
        <div className="text-sm tracking-wider font-light" data-id="element-70">THE CANDLE</div>
        <nav className="flex items-center gap-8" data-id="element-71">
          <button onClick={() => scrollToSection('story')} className="text-sm tracking-wide hover:text-gray-600 transition-colors" data-id="element-72">
            Story
          </button>
          <button onClick={() => scrollToSection('checkout')} className="text-sm tracking-wide hover:text-gray-600 transition-colors" data-id="element-73">
            Checkout
          </button>
        </nav>
      </div>
    </header>;
}